import { City } from 'cw-backend';

export class SearchedAddress {
    address: string;
    city: City;
    district: string;
    zipcode: string;
}